import React from 'react';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import DataTable from '../../../widgets/data-table/DataTable/DataTable';
import { TextField } from 'material-ui';
import * as ConfigType from '../../../../constants/ConfigType';
import { Button, styled, Switch, TextareaAutosize } from '@material-ui/core';
import parse from 'html-react-parser';
import './AdminPanelPage.css';

const StyledSwitch = styled((props) => (
  <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
  '& .MuiSwitch-switchBase': {
    transitionDuration: '300ms',
    '&.Mui-checked': {
      transform: 'translateX(18px)',
      color: '#EF6A00',
      '& + .MuiSwitch-track': {
        backgroundColor: 'gray',
        opacity: 1,
        border: 0
      }
    },
    '&.Mui-focusVisible .MuiSwitch-thumb': {
      color: '#33cf4d',
      border: '6px solid #fff'
    }
  },
  '& .MuiSwitch-track': {
    backgroundColor: 'gray',
    opacity: 1,
    transition: theme.transitions.create(['background-color'], {
      duration: 500
    })
  }
}));

function getDisplay(appConfig, props) {
  switch (appConfig.type) {
    case ConfigType.BOOLEAN:
      return (
        <StyledSwitch
          checked={appConfig.value === 'true'}
          onChange={(event) =>
            props.onValueChange(
              appConfig,
              event.target.checked ? 'true' : 'false'
            )
          }
        />
      );
    case ConfigType.INTEGER:
      return (
        <TextField
          className="config-editable"
          value={appConfig.value}
          onChange={(event) => {
            const regex = /^\d*$/g;
            const match = regex.exec(event.target.value);
            if (match) props.onValueChange(appConfig, event.target.value);
          }}
        />
      );
    case ConfigType.DECIMAL:
      return (
        <TextField
          className="config-editable"
          value={appConfig.value}
          onChange={(event) => {
            const regex = /^(\d*)([.]?)(\d*)$/g;
            const match = regex.exec(event.target.value);
            if (match) props.onValueChange(appConfig, event.target.value);
          }}
        />
      );
    case ConfigType.PERCENT:
      return (
        <TextField
          className="config-editable"
          value={appConfig.value * 100}
          onChange={(event) => {
            const regex = /^\d*$/g;
            const match = regex.exec(event.target.value);
            if (match && Number(event.target.value) <= 100)
              props.onValueChange(appConfig, event.target.value / 100);
          }}
        />
      );
    default:
      return (
        <TextareaAutosize
          className="config-editable"
          value={appConfig.value}
          onChange={(event) =>
            props.onValueChange(appConfig, event.target.value)
          }
        />
      );
  }
}

const columns = (props) => [
  {
    header: {
      display: props.intl.formatMessage({ id: 'config_name' })
    },
    accessor: (appConfig) => ({
      display: appConfig.configurationName
    })
  },
  {
    header: {
      display: props.intl.formatMessage({ id: 'config_description' })
    },
    accessor: (appConfig) => ({
      display: parse(
        `<span>${
          appConfig.description != null ? appConfig.description : ''
        }</span>`
      )
    })
  },
  {
    header: {
      display: props.intl.formatMessage({ id: 'config_value' })
    },
    accessor: (appConfig) => ({
      display: getDisplay(appConfig, props)
    })
  }
];

const AdminPanelPage = (props) => {
  return (
    <div>
      <div className="sized-table">
        <DataTable columns={columns(props)} bodyData={props.appConfigs} />
      </div>
      <Button className="config-save-button" onClick={props.onSaveChanges}>
        {props.intl.formatMessage({
          id: 'save'
        })}
      </Button>
    </div>
  );
};

AdminPanelPage.propTypes = {
  appConfigs: PropTypes.arrayOf(PropTypes.object.isRequired),
  onSaveChanges: PropTypes.func.isRequired
};

export default injectIntl(AdminPanelPage);
